import React, { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import { AppFooter as SharedAppFooter } from '@scryerlabs/ui'
import { environmentLabel, environmentColor } from '../../config/environment'
import {
  subscribeApiVersion,
  getApiVersionSnapshot,
} from '../../stores/api-info-store'

const AppFooter: React.FC = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()
  const apiVersion = useSyncExternalStore(
    subscribeApiVersion,
    getApiVersionSnapshot
  )

  return (
    <SharedAppFooter
      start={
        <span className="ms-1">
          &copy; {currentYear} {t('common:app.footer')}
        </span>
      }
      version={apiVersion || undefined}
      // The ribbon shows in EVERY environment here, prod included - deliberately the
      // opposite of the front office. It cautions people who can break something, and
      // staff moving between environments are exactly those people. A customer is not.
      environmentLabel={environmentLabel}
      environmentColor={environmentColor}
    />
  )
}

export default AppFooter
